<template>
  <div class="efactura-status">
    <!-- Badge maison, pas de <vs-chip> : la classe .ag-grid-cell-chip du thème
         centre la puce avec top:50% + translateY(-50%). C'est un hack qui ne
         tombe juste que si la puce est SEULE dans une cellule non-flex ; ici la
         cellule centre déjà son contenu, et les deux se cumulent — la puce sort
         de la ligne. -->
    <span class="efactura-badge" :class="'efactura-badge--' + tone" :title="data.efactura_alert_detail || ''">{{ label }}</span>
    <!-- Robot « messages ANAF » (migration 103) : une facture « ok » peut ne jamais
         avoir atteint le client (BT-47). Rouge si la fiche porte un CUI aujourd'hui
         (partie en zéros à tort), gris si la fiche n'a rien (personne physique, B2C
         normal). Le storno, quand il existe, dit que le rouge est traité. -->
    <span v-if="data.efactura_alert === 'NOT_DELIVERED'" class="efactura-sub" :class="data.storno_no ? 'efactura-sub--done' : 'efactura-sub--todo'">
      {{ data.storno_no ? 'storno ' + data.storno_no : 'storno to do' }}
    </span>
    <!-- Les identifiants ANAF ont leurs colonnes (UPLOAD ID / DOWNLOAD ID) depuis
         le centralisateur du 2026-10-29 : ici, le seul badge. -->
  </div>
</template>

<script>
export default {
  name: 'CellRendererSpvStatus',
  computed: {
    data () {
      return this.params.data || {}
    },
    // « ok » = l'ANAF a validé et signé le document. Il ne dit PAS que le client
    // l'a reçu : une facture partie en 13 zéros (client sans CUI sur sa fiche)
    // est « ok » sans jamais atteindre un SPV. D'où « VALIDATED BY ANAF », pas
    // « SENT TO CLIENT » (comptable, 2026-10-29).
    label () {
      if (this.data.efactura_alert === 'NOT_DELIVERED') return 'NOT DELIVERED (BT-47)'
      if (this.data.efactura_alert === 'ANAF_ERROR') return 'ANAF ERROR'
      if (this.data.efactura_alert === 'B2C_PERSON') return 'B2C · PRIVATE PERSON'
      if (this.data.efactura_stare === 'ok') return 'VALIDATED BY ANAF'
      if (this.data.efactura_stare === 'nok') return 'REJECTED BY ANAF'
      if (this.data.efactura_stare === 'in prelucrare') return 'ANAF PROCESSING'
      return 'NOT SENT'
    },
    tone () {
      if (this.data.efactura_alert === 'B2C_PERSON') return 'b2c'
      if (this.data.efactura_alert) return 'alert'
      if (this.data.efactura_stare === 'ok') return 'ok'
      if (this.data.efactura_stare === 'nok') return 'ko'
      if (this.data.efactura_stare === 'in prelucrare') return 'wip'
      return 'todo'
    }
  }
}
</script>

<style scoped>
.efactura-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  line-height: 1.25;
  overflow: hidden;
}

.efactura-badge {
  display: inline-block;
  max-width: 100%;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.5;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.efactura-badge--todo { background-color: #ff9f43; }
.efactura-badge--ko { background-color: #ea5455; }
.efactura-badge--wip { background-color: #7da7bc; }
.efactura-badge--ok { background-color: #28c76f; }
.efactura-badge--alert { background-color: #b42318; }
.efactura-badge--b2c { background-color: #8c979a; }

.efactura-sub {
  font-size: 0.65rem;
  line-height: 1.3;
  white-space: nowrap;
}
.efactura-sub--todo { color: #b42318; font-weight: 600; }
.efactura-sub--done { color: #6b716d; }
</style>
